import Vue from 'vue';
import EventService from "../../services/EventService";

export const namespaced = true;

/* 'me' contains everything returned by the API_URLS.ME service
 */
export const state = {
    loading: -1,  // Initial no-load state
    cached: false,
    me: {
        token: null,
//        event: null,
        settings: null,
        urls: null,
        attendee: null,
        attendees: null,
        organisation: null,
        group: null,
        notes: null
    }
};

export const mutations = {
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_CACHED(state, value) {
        state.cached = value;
    },
    SET_ME(state, meObj) {
        state.me = meObj;

        // Add extra data 
        // state.me.event.startObj = new Date(state.me.event.start);
        // let endObj = new Date(state.me.event.end);
        // endObj.setHours(23,59,59);
        // state.me.event.endObj = endObj;
        state.me.event.startObj = new Date(state.me.event.start_tz);
        state.me.event.endObj = new Date(state.me.event.end_tz);
    },
    ADD_NOTE(state, note) {
        state.me.notes.push(note);
    },
    REMOVE_NOTE(state, note) {
        const index = state.me.notes.findIndex(item => item.id === note.id);
        if (index !== -1) { state.me.notes.splice(index, 1); }
    },
    SET_ORGANISATION(state, org) {
        // Update me.attendee ~ IF matching
        if (state.me.organisation.id === org.id) {
            Vue.set(state.me, 'organisation', org);
        }
    },
    SET_ATTENDEE(state, attendee) {
        // Update me.attendee ~ IF matching
        if (state.me.attendee.id === attendee.id) {
            Vue.set(state.me, 'attendee', attendee);
        }
    },
    SET_ATTENDEE_IN_ATTENDEES(state, attendee) {
        // Update me.attendees
        const index = state.me.attendees.findIndex(item => item.id === attendee.id);

        if (index !== -1) {
            Vue.set(state.me.attendees, index, attendee);
        } else {
            state.me.attendees.push(attendee);
        }
    }
};

export const actions = {
    async fetchMe(context, doCache) {
        // console.log("Fetch ME");
        context.commit('SET_LOADING', 0);
        return EventService.getMe(doCache)
            .then(response => {
                console.log("fetchMe", response);
                context.commit('SET_LOADING', 50);
                context.commit('SET_ME', response.data);
                context.commit('SET_CACHED', Boolean(response.isCached))
                context.commit('SET_LOADING', 100);
                // console.log("Fetch ME: SET_ME");
            })
            .catch(error => {
               console.log('getMe failed: ', error.message);
               context.commit('SET_LOADING', 101); // Error state
               throw new Error('Could not load me');
            });
            // .then(() => {
            //     context.commit('SET_LOADING', 100);
            //     console.log("/Fetch ME");
            // });
    },
    insertMe(context, data) {
        context.commit('SET_ME', data);
    },
    updateAttendee(context, attendee) {
        // Update me.attendee (if same) and matching attendee in attendees
        // Add a new attendee if no match
        context.commit('SET_ATTENDEE', attendee);
        context.commit('SET_ATTENDEE_IN_ATTENDEES', attendee);
    },
    updateOrganisation(context, organisation) {
        context.commit('SET_ORGANISATION', organisation);
    },
    reset(context) {
        context.commit('SET_ME', { me: {
            token: null,
            settings: null,
            urls: null,
            attendee: null,
            organisation: null,
            group: null,
            notes: null
        }});
    },
    addNote(context, note) {
        context.commit('ADD_NOTE', note);
    },
    removeNote(context, note) {
        context.commit('REMOVE_NOTE', note);
    }

};

export const getters = {
    isCached: (state) => {
        return state.isCached;
    },
    getSetting: (state) => (name) => {
        if (state.me && state.me.settings) {
            return state.me.settings[name] || false;
        }
        return false;
    },
    currentAttendee: (state) => {
        return state.me.attendee;
    },
    getSettingByName: (state) => (name, fallback) => {
        return state.me.settings[name] || fallback;
    },
    // authToken: (state) => {
    //     return state.me.token;
    // },
};

